import { mapActions } from "vuex";
import HeaderView from "@/views/HeaderView";
import ViewFooter from "@/components/ViewFooter.vue";
import QuestionnaireDialog from "@/views/QuestionnaireDialog.vue";
import FAQDialog from "./views/HeaderView/FAQDialog.vue";
export default {
  name: "App",
  components: {
    HeaderView,
    ViewFooter,
    QuestionnaireDialog,
    FAQDialog
  },
  methods: {
    ...mapActions(["initializeMode"]),
    handleScroll() {
      const ele = document.getElementsByTagName('main')[0];
      const scrollHeight = ele.scrollHeight;
      const clientHeight = ele.clientHeight;
      if (scrollHeight > clientHeight) {
        ele.style.overflowY = 'scroll';
      } else {
        ele.style.overflowY = 'auto';
      }
    }
  },
  created() {
    this.initializeMode();
  },
  mounted() {
    this.handleScroll();
    window.addEventListener('resize', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleScroll);
  }
};